import React from "react";
import { Link } from "react-router-dom";
import ComicModel from "../../../models/ComicModel";

export const ReturnComic: React.FC<{ comic: ComicModel }> = (props) => {
	return (
		<div className="col-xs-6 col-sm-6 col-md-4 col-lg-3 mb-3">
			<div className="text-center">
				{props.comic.img ? (
					<img width="151" height="233" className="extra-shadow mb-2" src={props.comic.img}></img>
				) : (
					<img width="151" height="233" className="extra-shadow mb-2" src={require('./../../../Images/CoverImages/notFound.png')}></img>
				)}

				<h6 className="mt-2" style={{fontWeight: "bold"}}>{props.comic.title}</h6>
				<p>{props.comic.author}</p>
				<Link className="btn btn-red text-white" to={`/checkout/${props.comic.id}`}>
					Reserve
				</Link>
			</div>
		</div>
	);
};
